
<div class="jumbotron">
    <div class="container">

        <div class="d-flex text-white float-right">
            <a class="btn  btn-sm text-white mx-1 bg-dark" (click)='backClicked()'  translate><i class="fa fa-arrow-left"></i> BACK</a>
        </div>
        <div class="row">
            <div class="col-md-6 offset-md-3">

<form [formGroup]="usersEditForm" class="text-center border border-light p-5">

    <p class="h4 mb-4">Edit User</p>

  <!--{{usersEditForm.value | json}}-->
    <div class="form-group">
        <label class="float-left" translate>First Name</label>
        <input type="text" formControlName="firstName" class="form-control" [class.is-invalid]="formErrors.firstName" (blur)="logValidationErrors(usersEditForm)" />
        <div  [class.d-none]="!formErrors.firstName">
            <small>{{formErrors.firstName}}</small></div>
    </div>

    <div class="form-group">
        <label class="float-left">Middle Name</label>
        <input type="text" formControlName="middleName" class="form-control" />
     
    </div>

    <div class="form-group">
        <label class="float-left" translate>Last Name</label>
        <input type="text" formControlName="lastName" class="form-control" [class.is-invalid]="formErrors.lastName" (blur)="logValidationErrors(usersEditForm)" />
        <div  [class.d-none]="!formErrors.lastName">
            <small>{{formErrors.lastName}}</small></div>
    </div>
    <div class="form-group">
        <label class="float-left" translate>Email</label>
        <input type="text" formControlName="email" class="form-control" />
        
    </div>
 

    <!--  (change)='getAssetUser($event.target.value,"")'-->
        <div class="row pl-3 w-100 form-group mx-0 pl-0" style="padding-left: 0px!important ;" *ngIf="isSystemAdmin()">
            <div class="d-flex justify-content-between mb-1 w-100  border-bottom">
            <label class="float-left" translate>Branch</label>
            <button class="fa fa-plus  float-right bg-dark text-white" (click)='addModal(addBranchModal)' style="font-size: xx-small;"></button>
            </div>
            <select class=" form-control select2 select2-hidden-accessible"
                formControlName="branch" id="branch" name="branch"
                 tabindex="-1" aria-hidden="true"
                [class.is-invalid]="formErrors.branch"
                (blur)="logValidationErrors(usersEditForm)"  (change)="onChangeBranch($event.target.value)">
                <option value=""  disabled selected>Select</option>
                <option data-tagprefix='' *ngFor='let branchs of branchCategories' value={{branchs.name}}>{{branchs.name}}</option>
       
                

            </select>        
        </div>

        <div class="row px-3 form-group ">
           
            <label class="float-left" translate>Role</label>
            <select class=" form-control select2 select2-hidden-accessible"
                formControlName="role" id="role" name="role"
                 tabindex="-1" aria-hidden="true"
                [class.is-invalid]="formErrors.role"
                (blur)="logValidationErrors(usersEditForm)"  >
                <option value=""  disabled selected>Select</option>
                <option data-tagprefix='' *ngFor='let roles of roleCategories' value={{roles.name}}>{{roles.name}}</option>
                 

            </select>        
        </div>
    
        <div class="row pl-3 pt-2 form-group" >
       
            <input type="text" formControlName="userID" class="col-sm-10 form-control " placeholder="Username">
            <ngx-colors formControlName="color" *ngIf="usersEditForm.value.role=='Sales Representative' || usersEditForm.value.role=='Administrator' || usersEditForm.value.role=='Manager' || usersEditForm.value.role=='Power User'"  ngx-colors-trigger class="col-sm-2"  ></ngx-colors>
      
        </div>

 
    
    <button class="btn btn-dark my-4 btn-block" (click)='updateUser();'  translate>Update</button>

    <hr>

</form>

</div>
</div>
</div>
</div>


  <!----------Add Warehouse Location Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
     <ng-template #addBranchModal let-modal>
        <div class="modal-header">
         <h5 class="modal-title" id="statuLabel" translate>Add Branch</h5>
         <button type="button" class="close"style=" outline: none;" (click)="modal.dismiss()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
         </button>
        </div>
        
        <div class="modal-body">
         <form [formGroup]="addBranchForm" >
            <!--<input type="text" disabled class="form-control bg-white border-0 font-weight-bolder" formControlName="modalMsg" id="modalMsg">-->
            <div class=" border p-3 m-1 rounded   " >
                <h6 class="table-heading rounded text-white text-center p-3 bg-dark"  translate > Branch
                      <div class="p-1 mr-3">
                    <input class=" p-2 m-2 w-100 mx-2 text-center rounded "  type="text" placeholder="Search" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchText"
           aria-label="Search" >
         </div></h6>
                
        <div  style="overflow:auto;"  >
            <table class="table w-100  text-center"  style="font-size: 12px;">
                        
               <th>Name</th>
               <th>Action</th>
                                        
    
              
                <tr *ngFor='let location of branchCategories |  filter:searchText'>
                <td>{{location.name}}</td>
                <td><i class="fa fa-trash" style="cursor: pointer;" (click)='deleteBranch("branch",branch)'></i></td>
                </tr>
                
    
            </table>
       </div>
            </div>
    
          <div class="form-group row">
           
            <label for="newBranch" class="col-sm-4 col-form-label font-weight-bold" translate>New Location</label>
            <div class="col-sm-8">
             <input type="text"  class="form-control bg-white" formControlName="newBranch" id="newBranch">
            </div>
           </div>
      
         
         
          <div class="modal-footer">
           <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
           <button type="submit" class="btn btn-primary" (click)=addBranch(); translate>Add</button>
          </div>
         </form>
        </div>
       </ng-template>
<!----------------------------------------------------------------------------------------------------->
<button id="openSuccessModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessModal">Open Modal</button>
<!-- Modal -->
<div id="SuccessModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

                <h4 class="modal-title text-success" translate>SUCCESS</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body text-success">
                <p translate>User Account has been created.</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="backClicked()"
                    data-dismiss="modal" translate>Close</button>
            </div>
        </div>

    </div>
</div>

<!------------------------------------------------------------------------------------------>
<button id="openErrorModalButton" [hidden]="true" data-toggle="modal" data-target="#ErrorModal">Open Modal</button>
<!-- Modal -->
<div id="ErrorModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

                <h4 class="modal-title text-danger" translate>ERROR</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body text-danger">
                <p>{{error}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="backClicked()"
                    data-dismiss="modal" translate>Close</button>
            </div>
        </div>

    </div>
</div>